"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxFlash = require("redux-flash");
var _flashMessage = _interopRequireDefault(require("./flash-message"));
var _excluded = ["messages", "limit", "onDismiss"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 *
 * A component that displays multiple flash messages generated by [redux-flash](https://github.com/LaunchPadLab/redux-flash).
 * Most apps will need only one of these containers at the top level.
 * Will pass down any additional props to the inner `FlashMessage` components.
 *
 * @name FlashMessageContainer
 * @type Function
 * @param {Object} messages - The flash messages that will be displayed.
 * @param {Number} [limit] - Maximum number of concurrent messages to display
 * @example
 *
 * function MyApp ({ messages }) {
 *   return (
 *      <div>
 *         <FlashMessageContainer messages={ messages } />
 *         <RestOfTheApp />
 *      </div>
 *   )
 * }
 *
 */

var propTypes = {
  messages: _propTypes["default"].arrayOf(_reduxFlash.flashMessageType).isRequired,
  limit: _propTypes["default"].number,
  onDismiss: _propTypes["default"].func
};
var defaultProps = {
  limit: 5,
  onDismiss: null
};
function FlashMessageContainer(_ref) {
  var messages = _ref.messages,
    limit = _ref.limit,
    onDismiss = _ref.onDismiss,
    rest = _objectWithoutProperties(_ref, _excluded);
  var messagesToDisplay = messages.slice(0, limit);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flash-message-container",
    role: "alert"
  }, messagesToDisplay.map(function (message) {
    var _onDismiss = message.props.onDismiss || onDismiss;
    var onMessageDismiss = _onDismiss ? function () {
      return _onDismiss(message);
    } : null;
    return /*#__PURE__*/_react["default"].createElement(_flashMessage["default"], _extends({
      key: message.id,
      isError: message.isError
    }, rest, message.props, {
      onDismiss: onMessageDismiss
    }), /*#__PURE__*/_react["default"].createElement("p", null, message.message));
  }));
}
FlashMessageContainer.propTypes = propTypes;
FlashMessageContainer.defaultProps = defaultProps;
var _default = FlashMessageContainer;
exports["default"] = _default;